'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listenersMixin = exports.classMixin = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classMixin = exports.classMixin = {
  methods: {
    getUIClass: function getUIClass() {
      var ownName = this.constructor.options && this.constructor.options.name;
      var parentName = this.$parent && this.$parent.constructor.options && this.$parent.constructor.options.name;
      var inGroup = ownName && parentName && parentName.match(new RegExp('^' + ownName + '.*Group$'));
      return inGroup ? '' : 'ui';
    }
  }
};

var listenersMixin = exports.listenersMixin = {
  methods: {
    generateListeners: function generateListeners() {
      var listeners = (0, _extends3.default)({}, this.$listeners);

      Object.entries(this.$options.events || {}).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            name = _ref2[0],
            custom = _ref2[1].custom;

        if (custom) {
          delete listeners[name];
        }
      });

      return {
        on: listeners
      };
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-vue/dist/commonjs/lib/mixins.js
// module id = GCkY
// module chunks = 0